const manifest = require('../package.json')
const environment = process.env.REACT_APP_ENV || 'test'
// Test e produzione inviano le registrazioni a progetti distinti; gli altri ambienti richiedono un ID esplicito.
const clarityProjectIds = { test: 'avqxc97yx9', production: 'avqxyv7et1' }
const clarityProjectId = process.env.REACT_APP_CLARITY_PROJECT_ID || clarityProjectIds[environment] || ''
const configuration = {
  version: manifest.version,
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://api.test.plusadvance.com',
  cashPlanningApiBaseUrl: process.env.REACT_APP_CASH_PLANNING_API_BASE_URL || 'https://test-cashplanning.plusadvance.com',
  reverseFactoringApiBaseUrl: process.env.REACT_APP_REVERSE_FACTORING_API_BASE_URL || 'https://reverse-factoring.test.plusadvance.com',
  environment,
  clarityProjectId,
  clarityEnabled: Boolean(clarityProjectId),
  // L'anteprima è esplicita e limitata allo sviluppo/test: non abilita il tracker.
  clarityPreview: process.env.REACT_APP_CLARITY_PREVIEW === 'true' &&
    ['development', 'test'].includes(process.env.NODE_ENV) && environment !== 'production',
  gtmId: process.env.REACT_APP_GTM_ID || '',
  intercomKey: process.env.REACT_APP_INTERCOM_SECRET_KEY || '',
  c2aDefaultTransactionFee: Number(process.env.REACT_APP_C2A_DEFAULT_TRANSACTION_FEE) || 2.371
}

export default configuration
